export const HEADERS: HeadersInit = {
  "Content-Type": "application/json",
  "X-Hallow-Version": process.env.NEXT_PUBLIC_X_HALLOW_VERSION as string,
  "X-Platform": "web",
};
